import { useTranslationChange } from 'i18nano'
import { useEffect } from 'react'
import { updateStorage } from 'shared/lib/storage'
import { useAuthStore } from 'shared/store/auth'
import { isUserLanguage } from './language'

/** Applies the persisted server preference after authentication without a reload. */
export function LanguageSynchronizer() {
	const { lang, change } = useTranslationChange()
	const language = useAuthStore((state) => state.user.language)

	useEffect(() => {
		if (!isUserLanguage(language)) return
		if (lang !== language) change(language)
		updateStorage('user-preferences', { language })
	}, [change, lang, language])

	return null
}
